import { type Component, type ComponentProps, createContext } from "solid-js";
import type Viewer from "~/js/asset-viewport/viewer";
import type ImageViewer from "~/js/asset-viewport/viewers/image-viewer";
import type { GraphNode as NodeType, SocketOut } from "~/js/graph/node-socket-connection";
import type { IFileType } from "~/solidJs/shared";
import type { useHoverFeatureMenu } from "./methods";

export const HoverMenuContext = createContext<ReturnType<typeof useHoverFeatureMenu>>();

export enum ViewerType {
	Image = "image",
	Svg = "svg",
	Text = "text",
	Audio = "audio",
	Video = "video",
	Object3D = "object3d"
}

export enum HoverMenuSize {
	Medium = "medium",
	Large = "large"
}

export interface HoverFeatureAction {
	id: string;
	label: string;
	description?: string;
	Icon?: Component<ComponentProps<"svg">>;
	IconContext?: Component<ComponentProps<"svg">>;
	handler: () => void | Promise<void>;
	disabled?: () => boolean;
	isPremium?: () => boolean;
	associatedGlobalIds: string[];
}

export interface HoverFeatureMenuContext {
	viewerType: ViewerType;
	nodeUuid: string;
	socketName: string;
	size: { width: number; height: number };
	asset?: () => Promise<IFileType>;
	assetName?: string;
	socketsOutput?: SocketOut;
	node?: NodeType;
	viewer?: Viewer | ImageViewer;
	container: HTMLElement | null;
	onClose?: VoidFunction;
}

export interface HoverFeatureMenuState {
	isOpen: boolean;
	isContextMenuOpen: boolean;
	context: HoverFeatureMenuContext | null;
}

export type HoverFeatureMenuPaletteProps = Record<string, never>;
